import React from 'react';
import Layout from '../../components/layout/layout';

export default function CooptationPage() {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold mb-8">Programme de Cooptation</h1>
        <div className="prose max-w-none">
          <p className="text-lg mb-6">
            Notre programme de cooptation vous permet de recommander des talents et d'être récompensé pour votre contribution.
          </p>
        </div>
      </div>
    </Layout>
  );
}